import { env } from "@/env";
import { at } from "./austria";
import { be } from "./belgium";
import { hr } from "./croatia";
import { cz } from "./czechia";
import { dk } from "./denmark";
import { ee } from "./estonia";
import { fi } from "./finland";
import { fr } from "./france";
import { de } from "./germany";
import { gr } from "./greece";
import { hu } from "./hungary";
import { CountryCodeEnum, type Market } from "./i18n-config";
import { it } from "./italy";
import { lv } from "./latvia";
import { lt } from "./lithuania";
import { nl } from "./netherlands";
import { no } from "./norway";
import { pl } from "./poland";
import { pt } from "./portugal";
import { ro } from "./romania";
import { sk } from "./slovakia";
import { si } from "./slovenia";
import { es } from "./spain";
import { se } from "./sweden";

export const markets = {
  se,
  no,
  dk,
  fi,
  nl,
  de,
  at,
  be,
  cz,
  ee,
  es,
  fr,
  gr,
  hr,
  hu,
  it,
  lt,
  lv,
  pl,
  pt,
  ro,
  si,
  sk,
};

export function findMarketByLocale(locale: string): Market;

export function findMarketByLocale(locale: string, fallback: true): Market;

export function findMarketByLocale(
  locale: string,
  fallback: false,
): Market | undefined;

export function findMarketByLocale(locale: string, fallback: boolean = true) {
  if (!locale) return getDefaultMarket();

  let market = Object.values(markets).find(
    (market) => market.siteLocale === locale,
  );

  if (!market) {
    market = Object.values(markets).find((market) => market.locale === locale);
  }

  return market ?? (fallback ? markets.de : undefined);
}

export function findMarketByCode(code: string): Market;

export function findMarketByCode(code: string, fallback: true): Market;

export function findMarketByCode(
  code: string,
  fallback: false,
): Market | undefined;

export function findMarketByCode(
  code: string,
  fallback: boolean = true,
): Market | undefined {
  const market = Object.values(markets).find(
    (market) => market.countryCode === code,
  );

  return market ?? (fallback ? markets.de : undefined);
}

export function findMarketByContentfulLocale(locale: string): Market;

export function findMarketByContentfulLocale(
  locale: string,
  fallback: true,
): Market;

export function findMarketByContentfulLocale(
  locale: string,
  fallback: false,
): Market | undefined;

export function findMarketByContentfulLocale(
  locale: string,
  fallback: boolean = true,
) {
  return (
    Object.values(markets).find(
      (market) => market.contentfulLocale === locale,
    ) ?? (fallback ? markets.de : undefined)
  );
}

export function getDefaultMarket(): Market {
  if (env.NEXT_PUBLIC_APP_MARKET === "se") return markets.se;
  if (env.NEXT_PUBLIC_APP_MARKET === "no") return markets.no;
  return markets.de;
}

export const isValidMarket = (market?: string) => {
  if (!market) return false;
  return Object.values<string>(CountryCodeEnum).includes(market);
};
